import React, { useState } from 'react';

import '../styles/WhyPartnerUs.css';

import QuoteModal from './QuoteModal';

// Indian Flag SVG
import indiaFlag from '../assets/india.svg';


const WhyPartnerUs = () => {

  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);


  /* ==========================================
     QUOTE MODAL FUNCTIONS
  ========================================== */

  const openQuoteModal = () => {
    setIsQuoteModalOpen(true);
  };

  const closeQuoteModal = () => {
    setIsQuoteModalOpen(false);
  };


  /* ==========================================
     FEATURES DATA
  ========================================== */

  const features = [

  {
    id: 1,

    title: 'Instant Service & Replacement',

    description:
      'Get convenient service and replacement support through our partner-focused service model, helping clinics manage customer requirements efficiently.',

    highlight: 'Service Support',

    icon: 'fa-solid fa-bolt',

    iconType: 'fontawesome',

    gradient:
      'linear-gradient(135deg, #4a90e2, #2c5f8a)'
  },


  {
    id: 2,

    title: 'Affordable Solutions',

    description:
      'Quality-focused hearing aid solutions designed to offer competitive value for partners while helping make hearing care more accessible for customers.',

    highlight: 'Better Value',

    icon: 'fa-solid fa-indian-rupee-sign',

    iconType: 'fontawesome',

    gradient:
      'linear-gradient(135deg, #00b4d8, #0077b6)'
  },


  {
    id: 3,

    title: 'Real MRP',

    description:
      'We believe in transparent and responsible pricing. Our products carry clearly stated MRP, helping partners communicate pricing with greater clarity and build customer trust.',

    highlight: 'Transparent Pricing',

    icon: 'fa-solid fa-tags',

    iconType: 'fontawesome',

    gradient:
      'linear-gradient(135deg, #0877b8, #00b8ef)'
  },


  {
    id: 4,

    title: 'Made in India',

    description:
      'Proudly manufactured in India with a focus on quality, dependable supply and efficient support for our business partners.',

    highlight: 'Local Manufacturing',

    icon: indiaFlag,

    iconType: 'image',

    gradient:
      'linear-gradient(135deg, #ff9933, #138808)'
  },


  {
    id: 5,

    title: 'Pan-India Service Support',

    description:
      'Dedicated service support for partners across India, helping businesses receive assistance for their hearing aid requirements.',

    highlight: 'Nationwide Support',

    icon: 'fa-solid fa-location-dot',

    iconType: 'fontawesome',

    gradient:
      'linear-gradient(135deg, #20c997, #0ca678)'
  }

];

  /* ==========================================
     ICON RENDER FUNCTION
  ========================================== */

  const renderIcon = (feature) => {

    if (feature.iconType === 'image') {

      return (

        <img
          src={feature.icon}
          alt="Indian National Flag"
          className="why-partner-india-flag"
          loading="lazy"
        />

      );

    }


    return (

      <i
        className={feature.icon}
        aria-hidden="true"
      ></i>

    );

  };


  /* ==========================================
     COMPONENT
  ========================================== */

  return (

    <>

      <section
        id="why-partner"
        className="why-partner-section"
      >

        <div className="why-partner-container">


          {/* ==================================
              SECTION HEADER
          ================================== */}

          <div className="why-partner-header">

            <h2 className="why-partner-title">

              Why Partner With{' '}

              <span className="why-partner-title-highlight">
                Us?
              </span>

            </h2>


            <div className="why-partner-title-underline"></div>


            <p className="why-partner-subtitle">

              Join hands with India's most innovative hearing aid
              manufacturer. We offer unmatched advantages that
              help your business grow.

            </p>

          </div>



          {/* ==================================
              FEATURES GRID
          ================================== */}

          <div className="why-partner-grid">

            {features.map((feature) => (

              <div
                key={feature.id}
                className="why-partner-card"
              >


                {/* FEATURE ICON */}

                <div
                  className="why-partner-card-icon"
                  style={{
                    background: feature.gradient
                  }}
                >

                  {renderIcon(feature)}

                </div>



                {/* FEATURE CONTENT */}

                <div className="why-partner-card-content">


                  <h3 className="why-partner-card-title">

                    {feature.title}

                  </h3>



                  <p className="why-partner-card-description">

                    {feature.description}

                  </p>



                  {feature.highlight && (

                    <div className="why-partner-card-highlight">

                      {feature.highlight}

                    </div>

                  )}


                </div>


              </div>

            ))}

          </div>



          {/* ==================================
              TRUST BADGES
          ================================== */}

          <div className="why-partner-trust">


            {/* ISO CERTIFICATION */}

            <div className="why-partner-trust-item">

              <div className="why-partner-trust-icon">

                <i
                  className="fa-solid fa-certificate"
                  aria-hidden="true"
                ></i>

              </div>


              <span>
                ISO13485:2016 Certified Company
              </span>

            </div>



            {/* QUALITY ASSURED */}

            <div className="why-partner-trust-item">

              <div className="why-partner-trust-icon">

                <i
                  className="fa-solid fa-shield-halved"
                  aria-hidden="true"
                ></i>

              </div>


              <span>
                Quality Assured
              </span>

            </div>



            {/* MADE IN INDIA */}

            <div className="why-partner-trust-item">

              <div className="why-partner-trust-icon">

                <img
                  src={indiaFlag}
                  alt="Indian National Flag"
                  className="why-partner-india-flag"
                  loading="lazy"
                />

              </div>


              <span>
                Made in India
              </span>

            </div>


          </div>



          {/* ==================================
              PARTNERSHIP CTA
          ================================== */}

          <div className="why-partner-cta">

            <div className="why-partner-cta-content">


              <h3>

                Ready to Become Our Partner?

              </h3>



              <p>

                Join the fastest growing hearing aid
                network in India

              </p>



              <button
                type="button"
                onClick={openQuoteModal}
                className="why-partner-cta-btn"
              >

                Apply for Partnership


                <i
                  className="fa-solid fa-arrow-right"
                  aria-hidden="true"
                ></i>


              </button>


            </div>

          </div>


        </div>

      </section>



      {/* ==================================
          QUOTE MODAL
      ================================== */}

      <QuoteModal
        isOpen={isQuoteModalOpen}
        onClose={closeQuoteModal}
      />


    </>

  );

};

export default WhyPartnerUs;